module.exports = __webpack_public_path__ + "img/alfred_ford.1bac1cd9.jpg";